import { useQuery } from "@tanstack/react-query";

import type { PortfolioPermissionsDto } from "@/api/types";
import { FullSizeLoader } from "@/design-system/FullSizeLoader";
import { usePortfolioQueries } from "@/queries/portfolio/queryOptions";

import { ErrorPage } from "../Error/ErrorPage";

interface RequirePortfolioAuthProps {
  permission: (permission: PortfolioPermissionsDto) => boolean;
  children: React.ReactNode;
}

export function RequirePortfolioAuth({ permission, children }: RequirePortfolioAuthProps): React.ReactNode {
  const portfolioQueries = usePortfolioQueries();
  const {
    data: portfolioPermissions,
    isPending: isPendingPortfolioPermissions,
    error: errorPortfolioPermissions,
  } = useQuery(portfolioQueries.permissions());

  if (isPendingPortfolioPermissions) {
    return <FullSizeLoader withPadding />;
  }

  if (errorPortfolioPermissions) {
    return <ErrorPage error={errorPortfolioPermissions} />;
  }

  return permission(portfolioPermissions) ? children : <ErrorPage status={403} />;
}
